// when we can't use component, but should be able to, i think
// some functions are used here and in the dialog modal component,
// i think they can be reused in the future

// all dialogs but not from component, bc they don't have '.modal'
const dialogs = [...document.querySelectorAll('dialog.modal')];
const modalTriggers = [...document.querySelectorAll('.dialog-modal__trigger')];

const setModalContent = (trigger, dialog) => {
  const content = trigger.querySelector('.paragraph--image').innerHTML;
  const contentPlaceholder = dialog.querySelector('.dialog-modal__content');
  contentPlaceholder.innerHTML = content;
};

const removeModalContent = (dialog) => {
  const contentPlaceholder = dialog.querySelector('.dialog-modal__content');
  contentPlaceholder.innerHTML = '';
};

const openModalWithHistory = (type = null) => {
  // @todo do we not do this for all dialogs?
  if (type !== null) {
    const url = new URL(window.location);
    url.searchParams.set('modal', type.replace('-modal', ''));
    window.history.replaceState({ path: url.href }, '', url.href);
  }
};

const closeModalWithHistory = () => {
  const url = new URL(window.location);
  url.searchParams.delete('modal');
  window.history.replaceState({ path: url.href }, '', url.href);
};

const closeModal = (dialog) => {
  dialog.setAttribute('closing', '');

  dialog.addEventListener(
    'animationend',
    () => {
      dialog.removeAttribute('closing');
      dialog.close();
    },
    { once: true },
  );

  // remove the parameters
  closeModalWithHistory();
};

const lightDismiss = ({ target: dialog }) => {
  if (dialog.nodeName === 'DIALOG' || dialog.getAttribute('open')) {
    closeModal(dialog);

    if (dialog.id === 'image-resize') {
      removeModalContent(dialog);
    }
  }
};

const closeOnClick = (dialog) => {
  const close = dialog?.querySelector('.dialog-modal__close');
  if (close) {
    close.addEventListener('click', () => {
      closeModal(dialog);
    });
  }

  // close on outside click
  document.addEventListener('click', lightDismiss);
};

const addTriggerEvents = () => {
  modalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const dialogId = trigger.getAttribute('data-modal-id');
      const dialog = dialogs.find((d) => d.id === dialogId);

      // set the content if dialog is for image resize
      if (dialogId === 'image-resize') {
        setModalContent(trigger, dialog);
      }

      if (dialog) {
        dialog.showModal();
        // add parameters
        openModalWithHistory(dialogId);
      }

      // add close event if dialog is open
      closeOnClick(dialog);
    });
  });
};

const openModalOnLoad = (allDialogs) => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams) {
    const dialog = allDialogs.find(
      (d) => d.id === `${urlParams.get('modal')}-modal`,
    );

    dialog?.showModal();

    // add close event if dialog is open
    closeOnClick(dialog);
  }
};

(() => {
  if (dialogs.length > 0 && modalTriggers.length > 0) {
    // listen for events on dialogs
    addTriggerEvents();
    // open the dialog on page load,
    // if URL parameter is set
    openModalOnLoad(dialogs);
  }
})();
